import { pb } from './pocketbase';
import type { Stock } from '../types/stock';

/** Hämta alla stocks sorterade på ticker. */
export async function listStocks(): Promise<Stock[]> {
  const records = await pb.collection('stocks').getFullList<Stock>({
    sort: 'ticker',
  });
  return records;
}